// extracted by mini-css-extract-plugin
export default {"tailSquishTransform":"translateY(7px) scaleY(0.8)","icon":"BackIcon_icon__Y2niC","tail":"BackIcon_tail__mHFTr","arrow":"BackIcon_arrow__9ndc9"};